import { Button, Text } from "@mbank-design/design-system/components";
import { Link } from "react-router-dom";

import "./index.scss";
import { FontColor } from "@mbank-design/design-system/enums";

export const SpecialContactTile = () => {
  const handleRedirect = () => {
    window.location.href = "/formularz-kontaktowy-zamow-auto";
  };
  return (
    <div className="special-contact-tile" onClick={handleRedirect}>
      <div className="special-contact-tile__content">
        <div className="special-contact-tile__content__title">
          <Text as="h2" styledAs={"h1"} color={FontColor.LIGHT}>
            zamów samochód <br/> dokładnie taki, jak chcesz
          </Text>
        </div>
        <div className="special-contact-tile__content__description">
          <Text as="p" styledAs={"body"} color={FontColor.LIGHT}>
            wybierz markę, model i wyposażenie – my zajmiemy się resztą
          </Text>
        </div>
        <div className="special-contact-tile__content__button" >
          <Link to="/formularz-kontaktowy-zamow-auto" >
            <Button buttonType="primary">zamów auto</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
